import React, { useState } from "react";
import "./membershipForm.css";
import { db } from "./firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const MembershipForm = () => {
  const [form, setForm] = useState({
    fullName: "", dob: "", gender: "", contact: "", email: "", address: "",
    occupation: "", course: "", organization: "", interests: [], otherInterest: "",
    heardFrom: "", otherSource: "", agree: false, image: null, imagePreview: null
  });

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    if (type === "file") {
      const file = files[0];
      if (file && file.size <= 2 * 1024 * 1024) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setForm((prev) => ({
            ...prev,
            image: file,
            imagePreview: reader.result,
          }));
        };
        reader.readAsDataURL(file);
      } else {
        alert("Image must be less than 2MB");
      }
    } else if (type === "checkbox" && name === "agree") {
      setForm({ ...form, agree: checked });
    } else if (type === "checkbox" && name === "interests") {
      const updated = checked
        ? [...form.interests, value]
        : form.interests.filter((i) => i !== value);
      setForm({ ...form, interests: updated });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.agree) return alert("You must accept the declaration.");

    const memberData = {
      fullName: form.fullName,
      dob: form.dob,
      gender: form.gender,
      contact: form.contact,
      email: form.email,
      address: form.address,
      occupation: form.occupation,
      course: form.course,
      organization: form.organization,
      interests: form.interests,
      otherInterest: form.otherInterest,
      heardFrom: form.heardFrom,
      otherSource: form.otherSource,
      timestamp: serverTimestamp(),
    };

    try {
      await addDoc(collection(db, "members"), memberData);
      alert("Form submitted successfully!");
      setForm({
        fullName: "", dob: "", gender: "", contact: "", email: "", address: "",
        occupation: "", course: "", organization: "", interests: [], otherInterest: "",
        heardFrom: "", otherSource: "", agree: false, image: null, imagePreview: null
      });
    } catch (error) {
      alert("Error saving data: " + error.message);
    }
  };

  return (
    
      <form className="membership-form" onSubmit={handleSubmit}>
      <h2> Become a Member of Navveer Foundation for Free</h2>

      <div className="image-upload-section">

        {/* <label> image session updated soon
          Upload Photo (Max 2MB):
          <input type="file" accept="image/*" onChange={handleChange} required />
        </label> */}
        {/* {form.imagePreview && (
          // <div className="image-preview">
          //   <img src={form.imagePreview} alt="Preview" />
          //   <p>This photo will be used only for ID. No misuse will happen.</p>
          // </div>
        )} */}
      </div>

      <input name="fullName" placeholder="Full Name" required onChange={handleChange} />
      <input name="dob" type="date" required onChange={handleChange} />
      <select name="gender" onChange={handleChange} required>
        <option value="">Select Gender</option>
        <option>Male</option>
        <option>Female</option>
        <option>Other</option>
      </select>
      <input name="contact" placeholder="Contact Number" required onChange={handleChange} />
      <input name="email" type="email" placeholder="Email Address" required onChange={handleChange} />
      <textarea name="address" placeholder="Residential Address" required onChange={handleChange} />

      <select name="occupation" onChange={handleChange} required>
        <option value="">Select Occupation</option>
        <option value="Student">Student</option>
        <option value="Employed">Employed</option>
        <option value="Other">Other</option>
      </select>

      {form.occupation === "Student" && (
        <>
          <input
            name="course"
            placeholder="School/College Name & Course/Class"
            onChange={handleChange}
            required
          />
        </>
      )}

      {form.occupation === "Employed" && (
        <>
          <input
            name="organization"
            placeholder="Organization/Employer"
            onChange={handleChange}
            required
          />
        </>
      )}

      <fieldset>
        <legend>Areas of Interest (Check all that apply):</legend>
        <label><input type="checkbox" name="interests" value="Education" onChange={handleChange} /> Education & Libraries</label>
        <label><input type="checkbox" name="interests" value="Financial Support" onChange={handleChange} /> Financial Support & Schemes</label>
        <label><input type="checkbox" name="interests" value="Healthcare" onChange={handleChange} /> Healthcare & Wellness</label>
        <label><input type="checkbox" name="interests" value="Spiritual" onChange={handleChange} /> Spiritual & Religious</label>
        <label><input type="checkbox" name="interests" value="Social Welfare" onChange={handleChange} /> Social Welfare Programs</label>
        <label>
          <input type="checkbox" name="interests" value="Other" onChange={handleChange} />
          Other: <input name="otherInterest" onChange={handleChange} placeholder="Please specify" />
        </label>
      </fieldset>

      <fieldset>
        <legend>How did you hear about Navveer Foundation?</legend>
        <label><input type="radio" name="heardFrom" value="Website" onChange={handleChange} /> Website</label>
        <label><input type="radio" name="heardFrom" value="Social Media" onChange={handleChange} /> Social Media</label>
        <label><input type="radio" name="heardFrom" value="Friend/Family" onChange={handleChange} /> Friend/Family</label>
        <label><input type="radio" name="heardFrom" value="Event" onChange={handleChange} /> Event</label>
        <label>
          <input type="radio" name="heardFrom" value="Other" onChange={handleChange} />
          Other: <input name="otherSource" placeholder="Please specify" onChange={handleChange} />
        </label>
      </fieldset>

      <div className="declaration">
        <label>
          <input type="checkbox" name="agree" onChange={handleChange} required />
          I, the undersigned, hereby declare that the information provided above is true and correct to the best of my knowledge. I agree to abide by the rules and regulations of Navveer Foundation and actively contribute to its mission and objectives.
        </label>
      </div>

      <button type="submit">Submit Membership Form</button>
    </form>
    
  );
};

export default MembershipForm;
